import { render, staticRenderFns } from "./DepartmentsList.vue?vue&type=template&id=adfceb32"
import script from "./DepartmentsList.vue?vue&type=script&lang=js"
export * from "./DepartmentsList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsList.vue?vue&type=style&index=0&id=adfceb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports